import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { ListRow, Remove } from 'basic-components';

import { creatorCurvesActions } from 'actions/curves';

const Row = ({ scrollRef, groupName, product, root, index }) => {
  const dispatch = useDispatch(),
        removeItem = useCallback(() => dispatch(creatorCurvesActions.removeCurve(index)), [dispatch, index])
  return (
    <ListRow
        className={"ng-office-app__authed__content__basket__body__data__basket__items__item"}
        offset={8000}
        scrollContRef={scrollRef}
    >

      <div className="ng-office-app__authed__content__basket__body__data__basket__items__item__cell">
        {groupName}
      </div>
      <div className="ng-office-app__authed__content__basket__body__data__basket__items__item__cell">
        {product}
      </div>
      <div className="ng-office-app__authed__content__basket__body__data__basket__items__item__cell">
        {root}
      </div>
      <div 
          className="ng-office-app__authed__content__basket__body__data__basket__items__item__action"
          onClick={removeItem}
          tabIndex={0}
      >
        <Remove
            color="red-dark"
            height={16}
            width={16}
        />
      </div>
    </ListRow>
  )
}

Row.propTypes = {
  groupName: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  product: PropTypes.string.isRequired,
  root: PropTypes.string.isRequired,
  scrollRef: PropTypes.any.isRequired
}

export default Row;